import { useRef, useEffect } from 'react';

export function useOnceEffect(callback: () => void, condition: any = true) {
  const isCalledRef = useRef(false);

  useEffect(() => {
    if (condition && !isCalledRef.current) {
      isCalledRef.current = true;
      callback();
    }
  }, [callback, condition]);
}
